const eventActionTypes = {
	JoinClass: 'Join Class',
	LeaveClass: 'Leave Class',
	MissClass: 'Miss Class',
	MakeupClass: 'Makeup Class'
}

export default eventActionTypes
